import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'flex gap-1',
    starWrapper: 'text-icon-secondary-medium relative inline-block',
    star: 'h-6 w-6',
    starFilled: 'text-icon-star absolute top-0 left-0 overflow-hidden',
    iconFilled: '[&>path]:fill-brand-400'
  }
});
